import React from "react";
import i18n from "i18next";

import k from "src/i18n/keys";
import Common from "../Common";
import { FieldName } from "src/components/messages/Chat/Notification/styles";

import type { Message } from "src/types";

type Props = {
  message: Message;
};

const Success = ({ message }: Props) => {
  const { data } = message;

  const filledFieldCount = data.filled.length;
  const rejectedFieldCount = data.rejected.length;

  return (
    <Common {...message}>
      {" "}
      {i18n.t(k.ADDED)} {filledFieldCount}
      {rejectedFieldCount > 0 &&
        ` ${i18n.t(k.AND_REJECTED)} ${rejectedFieldCount}`}{" "}
      {i18n.t(k.AI_SUGGESTED_CHECKLIST_VALUES_FOR)}{" "}
      <FieldName>{data.field.label}</FieldName>{" "}
    </Common>
  );
};

export default Success;
